// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { columnsStyles } from "@insite/content-library/Widgets/ProductList/ProductListColumns";
import { GridOffset } from "@insite/mobius/GridContainer";
import { screen } from "@rugby/XDL/Helpers";
import { css } from "styled-components";

columnsStyles.container = {
    gap: 20,
    css: css`
        margin-top: 50px;
        padding-bottom: 40px;
        margin-bottom: 40px;
        &&::after {
            content: "";
            width: 100%;
            position: absolute;
            left: 0;
            padding-bottom: 40px;
            margin-bottom: 40px;
            border-bottom: 10px solid rgba(80, 106, 113, 0.07);
        }
        ${screen("lte", "sm")`
            margin-top: 16px;
        `};
        ${screen("lt", "sm")`
            ${GridOffset} {
                margin-right: 0px;
                margin-left: 0;
            }
        `}
    `,
};

columnsStyles.leftColumnGridItem = {
    width: [12, 12, 12, 3, 3],
};

columnsStyles.rightColumnGridItem = {
    width: [12, 12, 12, 9, 9],
};
